import * as React from "react";
import ReactPlayer from "react-player";
import { SourceProps } from "react-player/base";

const VideoCard = (props: { youtubeUrl: string , videoDescription: string | string[] | SourceProps[] | MediaStream | undefined; }) => {
  return (
    <>
      <div className="infobox_wrapper doctor_card">
        <div>
          <div>
            <div className="team_member">
              <div className="member_name video-memeber">
                <ReactPlayer
                  className="video-youtube-n"
                  controls
                  url={props.youtubeUrl}
                  config={{
                    youtube: {
                      playerVars: {
                        showinfo: 0, // Hide video info to reduce thumbnail size
                      },
                    },
                  }}
                />
              </div>
            </div>
          </div>
          <div className="video-description">
            <p>{props.videoDescription}</p>
            </div>
        </div>
      </div>
    </>
  );
};

export default VideoCard;
